<template>
  <div class="star-main" :class="starDisable"
       ref="cuteRate"
       @mouseleave="starMouseleave">
    <input type="hidden" :value="currentValue">
    <div class="star-full"
      v-for="i in count"
      :key="i"
      @mouseover="starMousemove(i)"
      @click="starClick(i)"
    >
      <div>
        <slot name="customHover" computeClass="char" v-if="i <= hoverIndex && (i > currentValue || hoverIndex <= currentValue && i >= hoverIndex)" />
        <slot name="customActive"
              v-else-if="i <= currentValue && i < hoverIndex || hoverIndex === -1 && i <= currentValue"
              computeClass="char"/>
        <slot name="customInactive" computeClass="char" v-else />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StarRate',
  props: {
    count: {
      type: Number,
      default: 5
    },
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    hoverChange: {
      type: Boolean,
      default: false
    },
    onHoverChange: {
      type: Function,
      default: () => {}
    },
    onChange: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      hoverIndex: -1,
      currentValue: this.value
    }
  },
  computed: {
    starDisable () {
      return this.disabled ? 'star-disable' : 'star-able'
    }
  },
  methods: {
    currentIndex () {
      return this.hoverIndex === -1 ? this.currentValue : this.hoverIndex
    },
    starMousemove (i) {
      if (window.innerWidth < 768) return
      if (this.disabled) return
      if (this.starHalf) {
        this.isHalf = false
      }
      this.hoverIndex = i
      this.changeValue(i)
    },
    starHalfMousemove (i) {
      if (this.disabled) return
      if (this.starHalf) {
        this.isHalf = true
      }
      this.hoverIndex = i
      this.changeValue(i)
    },
    changeValue (i) {
      if (this.hoverChange) {
        let value = this.isHalf ? i - 0.5 : i
        this.$emit('input', value)
        this.onHoverChange(value)
      } else {
        this.onHoverChange(this.value)
      }
    },
    starClick (i) {
      if (this.disabled) return
      const curValue = this.currentValue
      let value = this.isHalf ? i - 0.5 : i
      this.currentValue = value
      if (curValue === this.currentValue && this.allowClear) {
        this.currentValue = 0
        this.hoverIndex = -1
        value = 0
      }
      this.$emit('input', value)
      this.onChange(value)
      if (this.$mqAliases.isMobile) {
        this.starMouseleave()
      }
    },
    starMouseleave () {
      if (this.disabled) return
      this.hoverIndex = -1
      this.isHalf = this.starHalf && this.currentValue.toString().split('.').length > 1
      if (!this.hoverChange) return
      this.$emit('input', this.currentValue)
    }
  }
}
</script>

<style scoped lang="postcss">
* {
  margin: 0;
  padding: 0;
}
.star-main {
  margin: 10px auto;
  padding: 0;
  text-align: center;
  display: inline-block;
}
.char {
  color: var(--inactive-color);
  font-size: 22px;
  transition: all 0.3s ease-in-out;
}
.star-disable {
  .star-full {
    cursor: not-allowed;
    &:hover {
      transform: scale(1);
    }
  }
}
.star-full {
  position: relative;
  display: inline-block;
  transition: all 0.2s ease;
  margin-right: 22px;
  cursor: pointer;
}
.star-able {
  .star-full {
    &:hover {
      transform: scale(1.1);
      .icon-full, .icon-half {
        color: var(--hover-color-original-green)
      }
    }
  }
}
.star-half {
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
}
.icon-rate-2 {
  color: transparent;
}
.icon-full, .icon-half {
  color: var(--active-color);
}
.star-char {
  padding: 5px;
}
</style>
